<template>
  <SeoPage page-key="sviluppoAppTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'SviluppoAppTicinoPage'
})
</script>

